import { isEmpty, VFlow } from 'bold-ui'
import { RadioOption, resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import React from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoIndicatorHelper } from '../../components/ConsultaSeguimentoIndicatorHelper'
import { ConsultaSeguimentoIndicatorResultado } from '../../components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '../../components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '../../components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '../../components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioListField } from '../../components/PerguntaSimNaoRadioListField'
import { useConsultaSeguimentoSetResultado } from '../../hooks/useConsultaSeguimentoSetResultado'
import { PassouFalhouEnum } from '../../model-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta15Model,
  ConsultaSeguimentoPergunta15TentaImitarEnum,
} from './model-consultaSeguimentoPergunta15'
import {
  hasPergunta15TentaImitarAtLeastTwoSim,
  isPergunta15TentaImitarAllFilled,
} from './utils-consultaSeguimentoPergunta15'

interface ConsultaSeguimentoPergunta15FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta15Model>
}

export function ConsultaSeguimentoPergunta15Field(props: Readonly<ConsultaSeguimentoPergunta15FieldProps>) {
  const { name } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta15Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta15Model>({
    name,
    calculateResultado,
    conditionToCalculate,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        <ConsultaSeguimentoPerguntaHeader
          pergunta={MChatPerguntaEnum.PERGUNTA_15}
          title={<ConsultaSeguimentoPerguntaHeaderTitle sufix=' tenta copiar o que você faz?' />}
          status={value.status}
          field={<SimNaoSwitchButtonField name={name.PERGUNTA_15_HEADER} />}
        />
        {!isEmpty(value?.PERGUNTA_15_HEADER) && (
          <VFlow vSpacing={value?.PERGUNTA_15_HEADER === SimNaoEnum.SIM ? 0 : 1}>
            <ConsultaSeguimentoIndicatorStart />
            <VFlow>
              {value?.PERGUNTA_15_HEADER === SimNaoEnum.SIM && (
                <ConsultaSeguimentoIndicatorHelper
                  title='Por favor, dê um exemplo de algo que ele tenta copiar.'
                  subtitle='(Se o genitor não der um dos exemplos abaixo, perguntar cada um deles individualmente.)'
                />
              )}
              <PerguntaSimNaoRadioListField<ConsultaSeguimentoPergunta15TentaImitarEnum>
                name={name.PERGUNTA_15_TENTA_IMITAR}
                nameOutro={name.OUTRO}
                label='O seu filho tentar lhe imitar, se você...'
                description='Responda os exemplos até pontuar "Passou" ou "Falhou"'
                required
                options={PERGUNTA_15_TENTA_IMITAR_OPTIONS}
              />
            </VFlow>
          </VFlow>
        )}
      </VFlow>
      {value?.resultado && (
        <ConsultaSeguimentoIndicatorResultado
          text={{
            FALHOU: 'Sim, para um ou nenhum:',
            PASSOU: 'Sim, para dois ou mais:',
          }}
          resultado={value.resultado}
        />
      )}
    </VFlow>
  )
}

const PERGUNTA_15_TENTA_IMITAR_OPTIONS: RadioOption<ConsultaSeguimentoPergunta15TentaImitarEnum>[] = [
  {
    label: 'Põe a língua para fora?',
    value: ConsultaSeguimentoPergunta15TentaImitarEnum.POE_LINGUA_PRA_FORA,
  },
  {
    label: 'Faz um som engraçado?',
    value: ConsultaSeguimentoPergunta15TentaImitarEnum.FAZ_SOM_ENGRACADO,
  },
  {
    label: 'Dá tchau?',
    value: ConsultaSeguimentoPergunta15TentaImitarEnum.DA_TCHAU,
  },
  {
    label: 'Bate palmas?',
    value: ConsultaSeguimentoPergunta15TentaImitarEnum.BATE_PALMAS,
  },
  {
    label: 'Coloca os dedos nos seus lábios para sinalizar "Xiii"?',
    value: ConsultaSeguimentoPergunta15TentaImitarEnum.COLOCA_DEDOS_NOS_LABIOS,
  },
  {
    label: 'Manda um beijo?',
    value: ConsultaSeguimentoPergunta15TentaImitarEnum.MANDA_BEIJO,
  },
]

const calculateResultado = (values: ConsultaSeguimentoPergunta15Model) => {
  if (hasPergunta15TentaImitarAtLeastTwoSim(values)) {
    return PassouFalhouEnum.PASSOU
  } else {
    return PassouFalhouEnum.FALHOU
  }
}

const conditionToCalculate = (values: ConsultaSeguimentoPergunta15Model): boolean => {
  return hasPergunta15TentaImitarAtLeastTwoSim(values) || isPergunta15TentaImitarAllFilled(values)
}
